import {
  ReactToPhaserListeners,
  NotifyReact,
  PhaserListenForReact,
  NotifyReactEvents,
  RemoveListener,
} from 'Phaser/EventBus2';
import Phaser from 'phaser';

export default class PauseMenu extends Phaser.Scene {
  other: string | null = null;
  constructor() {
    super('PauseMenu');
  }
  create(): void {
    /*PhaserListenForReact(ReactToPhaserListeners.ResumeExercise(this.resume), undefined, {
      once: true,
      context: this,
    });
    PhaserListenForReact(ReactToPhaserListeners.ToggleExercise(this.resume), undefined, {
      once: true,
      context: this,
    });
    this.events.once('shutdown', () => {
      RemoveListener('ResumeExercise');
      RemoveListener('ToggleExercise', this.resume);
    });*/
  }
  resume() {
    /*console.log('resume');
    NotifyReact(NotifyReactEvents.ExerciseResumed(undefined));
    this.scene.resume(this.other!);
    (this.scene.get(this.other!) as Phaser.Scene & { resume(): void }).resume();
    this.scene.stop();*/
  }
  init({ other }: { other: string }): void {
    /*this.other = other;
    NotifyReact(NotifyReactEvents.ExercisePaused({}));*/
  }
}
